import React from "react";
import Legal from "../components/Legal.jsx";
import { PRIVACY } from "../data/legal.js";

const Privacy = () => <Legal title={PRIVACY.title} intro={PRIVACY.intro} blocks={PRIVACY.blocks} />;

export default Privacy;
